import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import { logtail } from '@/utils/logtail';

const teamMembersEndpoint = apiUrl + 'fetchTeamMembers/';

export const fetchTeamMembers = async ({
  TeamUUID,
  OrgUUID,
}: {
  TeamUUID: string;
  OrgUUID: string;
}) => {
  try {
    const response = await postWithAuth(teamMembersEndpoint, {
      TeamUUID,
      OrgUUID,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (typeof data === 'string') {
      return JSON.parse(data);
    }
    return data;
  } catch (error) {
    logtail.error(error + 'error in fetchTeamMembers', {
      TeamUUID,
    });
    logtail.flush();
    return {
      Error: 'Error fetching team members',
    };
  }
};
